import { useTheme } from 'styled-components';

import Accordion from '../../../../ui/Accordion';

const FAQs = () => {
  const theme = useTheme();
  const faqs = [
    {
      title: 'How are these savings calculated?',
      content: (
        <>
          <p>
            We’ve used your data where possible to simulate what would have happened to your household bills if you were
            on this tariff - both with and without {theme.language.appName}.
          </p>
          <p>
            This is not going to be 100% accurate - we can't guarantee Agile prices in the future - but should give you
            some idea as to the effect of being on this tariff with {theme.language.appName}.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="mt-4">
      <Accordion data={faqs} />
    </div>
  );
};

export default FAQs;
